module.exports = __webpack_public_path__ + "img/d75c4415-9e90-4353-bdf7-396dc09ecbd4.54aa27cf.png";